import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  TextField,
  Box,
} from "@mui/material";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { gql } from "@apollo/client";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { useLoading } from "../../context/loading";
import { cancelApiIntergration } from "../../functions/cancelApi/cancelApi";
import Swal from "sweetalert2";
const cancelpermission = gql`
  mutation CancelPermission($permissionId: ID!) {
    CancelPermission(permissionId: $permissionId) {
      success
    }
  }
`;
function ViewScreen_Premission() {
  const [employeeData, setemployeeData] = useState([]);
  const [id, setId] = useState(null);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const { circleLoading, setCirleLoading } = useLoading();

  const navigate = useNavigate();
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getemployeedata(id);
    }
  }, []);

  const getemployeedata = async (id) => {
    const query = ` query GetPermissionById($id: ID!) {
  permissionById(id: $id) {
    data{
    id
    user {
      id
      username
      firstName
      lastName
    }
    permissionOn
    permissionFrom
    permissionTill
    reason
    balanceHours
    teamApproval
    hrApproval
    status
    createdAt
    }
  
  }
}
  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response0000", response.data.data.permissionById.data);

      // const leaveDatass = response.data.data.getLeaveById;
      // console.log('leaveDatass:',leaveDatass);
      setemployeeData(response.data.data.permissionById.data[0]);
      //  setemployeeData(leaveDatass)
    } catch (error) {
      console.log("ReponseError:", error);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // This will return 'dd/mm/yyyy' format
  }

  const handleclose = () => {
    navigate("/permission");
  };

  const handleCancelLeave = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to cancel your Permission.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        const { status } = await cancelApiIntergration(cancelpermission, id);
        setCirleLoading(false);

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Cancel successfully",
          showConfirmButton: false,
          timer: 4500,
        }).then(() => {
          navigate("/permission");
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const today = new Date();

  const formattedDate =
    today.getFullYear() +
    "-" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(today.getDate()).padStart(2, "0");

  const [time, setTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const today = new Date();
      const hours = today.getHours() % 12 || 12;
      const minutes = String(today.getMinutes()).padStart(2, "0");
      const ampm = today.getHours() >= 12 ? "PM" : "AM";

      setTime(`${hours}:${minutes}${ampm}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  const convertTo12HourFormat = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string" || !timeStr.includes(":")) {
      console.error("Invalid time format:", timeStr);
      return "Invalid Time";
    }

    let [hours, minutes] = timeStr.split(":").map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
      console.error("Time contains invalid numbers:", timeStr);
      return "Invalid Time";
    }

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12 and 13+ to 1+

    return `${hours}:${minutes.toString().padStart(2, "0")}${ampm}`;
  };

  const timegiven = convertTo12HourFormat(employeeData.permissionFrom);

  const checkdate = formattedDate <= employeeData.permissionOn;
  const checktime = time >= timegiven;

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ padding: 2, boxShadow: 3 }}>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold" textAlign="center">
                Leave Details
              </Typography>
            </Stack>
          }
        />
        <CardContent>
          <Grid container spacing={1} marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>User Name:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.user?.firstName?.toUpperCase() + " " + employeeData?.user?.lastName?.toUpperCase()}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Permission On:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.permissionOn}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Permission From:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.permissionFrom}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong> Permission Till:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.permissionTill}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Balance Hours:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.balanceHours}
                  </span>
                </Typography>
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <Typography variant="h6">
                  <strong>Reason:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData.reason}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Team Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.teamApproval
                      ? employeeData?.teamApproval.charAt(0).toUpperCase() +
                        employeeData?.teamApproval.slice(1)
                      : ""}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>HR Approval:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.hrApproval
                      ? employeeData?.hrApproval.charAt(0).toUpperCase() +
                        employeeData?.hrApproval.slice(1)
                      : ""}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: "#67748E" }}>
                    {employeeData?.status
                      ? employeeData?.status.charAt(0).toUpperCase() +
                        employeeData?.status.slice(1)
                      : ""}
                  </span>
                </Typography>
                {/* <Typography variant="h6">
                        <strong>Created AT:</strong>{" "}
                        <span style={{ color: "#67748E" }}>
                        {employeeData?.createdAt}
          
                          </span>
                      </Typography> */}
              </Stack>
            </Grid>
          </Grid>

          {/* Close and Action Buttons */}
          <Grid container spacing={2} justifyContent="center" marginTop={4}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <MaterialButton
                variant="contained"
                color="dark"
                onClick={() => handleclose()}
              >
                Close
              </MaterialButton>
              {checkdate &&
                !checktime &&
                employeeData?.status?.toLowerCase() !== "cancelled" &&
                employeeData?.status?.toLowerCase() !== "rejected" && (
                  <MaterialButton
                    variant="contained"
                    color="dark"
                    onClick={() => handleCancelLeave()}
                    sx={{ marginLeft: "10px" }}
                  >
                    Cancel Permission
                  </MaterialButton>
                )}
            </Box>
          </Grid>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default ViewScreen_Premission;
